import { CheckboxConfig, LinkConfig, NativeCheckboxConfig, css, media, tokens } from '@sail/ui';
import { assignProps } from '@sail/engine';
import { helmTokens } from '../tokens';
import { CheckIcon } from '../../components/icons';
export const checkboxCustomization = CheckboxConfig.customize({
    uses: [
        css({
            fontWeight: 'light',
            display: 'grid',
            gridTemplateColumns: '16px 1fr',
            gridTemplateAreas: '"input label"',
            columnGap: '0',
            [media.up(tokens.viewport.small)]: {
                gridTemplateColumns: 'calc(33.33% + 16px) 16px 1fr',
                gridTemplateAreas: '"whiteSpace input label"'
            }
        }),
        LinkConfig.customize({
            uses: [
                css({
                    fontSize: 'body.medium',
                    fontWeight: 'semibold'
                })
            ]
        })
    ],
    subviews: {
        inputs: {
            uses: [
                css({
                    gridArea: 'input'
                })
            ]
        },
        label: {
            uses: [
                css({
                    gridArea: 'label',
                    fontWeight: 'normal',
                    cursor: 'pointer',
                    marginLeft: 'small'
                })
            ]
        }
    }
});
export const nativeCheckboxCustomization = NativeCheckboxConfig.customize({
    uses: [
        css({
            width: 'medium',
            height: 'medium',
            backgroundColor: '#e7ecf1',
            '[aria-invalid="false"]': {
                boxShadow: `none`
            },
            '[aria-invalid="true"]': {
                boxShadow: `inset 0 0 0 ${tokens.color.border.form.error}`
            },
            '[aria-invalid="true"]:checked': {
                boxShadow: `inset 0 0 0 ${tokens.color.border.form.error}`
            },
            ':hover': {
                backgroundColor: 'rgba(99, 91, 255, 0.2)',
                transition: `all ${helmTokens.transition.hover}`
            }
        })
    ],
    subviews: {
        checked: {
            uses: [
                assignProps({
                    icon: CheckIcon
                }),
                css({
                    height: 'small'
                })
            ]
        }
    }
});

//# sourceMappingURL=checkbox.js.map